import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Vestiging } from 'src/app/models/vestiging.model';
import { LocationService } from 'src/app/services/location.service';
import { PageService } from 'src/app/services/page.service';
import { SpecialisatieService } from 'src/app/services/specialisatie.service';
import { TeamService } from 'src/app/services/team.service';

@Component({
  selector: 'app-vestiging',
  templateUrl: './vestiging.component.html',
  styleUrls: ['./vestiging.component.sass']
})
export class VestigingComponent implements OnInit {

  vestId: any;
  vestiging: any = {};
  members:any = [];
  specs:any = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private locationService:LocationService,
    private teamService:TeamService,
    private specService:SpecialisatieService,
    private pageService:PageService
    ) { }

  ngOnInit(): void {
    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;

    this.vestId = params["vestiging"];

    this.locationService.getVestiging(this.vestId).subscribe(data => {
        this.vestiging = this.locationService.populateVestiging(data.data[0]);
        this.pageService.setCurrentHeader(this.vestiging.banner_image);
    });

    this.teamService.getTeamForVestiging(this.vestId).subscribe(data => {
        data.data.forEach((element: any) => {
          let member = this.teamService.populateTeamlid(element);
          this.members.push(member);

          for(let spec of member.specialisaties) {
            this.specService.getSpecialisatie(spec.id).subscribe(data => {
              let dspec = this.specService.populateSpecialisatie(data.data[0]);
              this.specs.push(dspec);
            });
          }
        });
    });
  }

  mapLink(vestiging:Vestiging): string {
    return 'https://www.google.com/maps/embed?'+vestiging.maps_link;
  }

}
